import { AlertTriangle } from 'lucide-react';
import { Link } from 'react-router';
import { useAuth } from '../../hooks/useAuth';

/**
 * Mail that would not reach anyone: recorded as sent by the log provider, or stuck in the Outbox with no sender set up,
 * because no connected mailbox sends it. Not blocking — evaluation installs use the log provider on purpose.
 */
export function DeliveryWarning({ message }: { message: string }) {
  const { can } = useAuth();
  return (
    <div role="status" className="rounded-md border border-amber-200 bg-amber-50 p-3 text-[13px] text-amber-900">
      <p className="flex items-center gap-1 font-medium">
        <AlertTriangle className="size-4" /> Won’t actually be delivered
      </p>
      <p className="mt-1">{message}</p>
      {can('settings:manage') ? (
        <Link to="/settings/email" className="mt-1 inline-block font-medium underline">
          Open email settings
        </Link>
      ) : (
        <p className="mt-1">Settings → Email is for administrators: ask one to connect a mailbox for sending.</p>
      )}
    </div>
  );
}
